export default "__VITE_ASSET__C0BLFko2__"